var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0393.725c7.90554 0 14.31414 6.40906 14.31414 14.31415 0 7.90604-6.4081 14.31415-14.31414 14.31415-7.90605 0-14.31416-6.4081-14.31416-14.31415C.72514 7.13406 7.13374.725 15.0393.725zm0 1c-7.35325 0-13.31416 5.96133-13.31416 13.31415 0 7.35376 5.9604 13.31415 13.31415 13.31415 7.35376 0 13.31416-5.9604 13.31416-13.31415 0-7.35282-5.9609-13.31415-13.31415-13.31415zm.462 19.59627v6.9078h-1v-6.9078h1zm-6.75965-6.75964v1H1.83531v-1h6.90634zm19.4271 0v1h-6.9078v-1h6.9078zM15.50132 1.89417v6.9078h-1v-6.9078h1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.9f2361b2.svg";
export { ForwardRef as ReactComponent };